var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInfoIconBlue = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9635 7.80859H11.9272C11.4908 7.80859 11.0908 8.17223 11.0908 8.64496C11.0908 9.11768 11.4545 9.48132 11.9272 9.48132H11.9635C12.3999 9.48132 12.7999 9.11768 12.7999 8.64496C12.7999 8.17223 12.4363 7.80859 11.9635 7.80859Z",
    fill: "#d2294b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9633 10.6836C11.527 10.6836 11.127 11.0472 11.127 11.52V17.12C11.127 17.5563 11.4906 17.9563 11.9633 17.9563C12.3997 17.9563 12.7997 17.5927 12.7997 17.12V11.4836C12.7997 11.0472 12.436 10.6836 11.9633 10.6836Z",
    fill: "#d2294b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9635 1.51953C5.89077 1.51953 0.945312 6.42862 0.945312 12.5014C0.945312 18.5741 5.89077 23.5195 11.9635 23.5195C18.0362 23.5195 22.9453 18.5741 22.9453 12.5014C22.9453 6.42862 18.0362 1.51953 11.9635 1.51953ZM11.9635 21.8832C6.79986 21.8832 2.58168 17.665 2.58168 12.5014C2.58168 7.33771 6.79986 3.11953 11.9635 3.11953C17.1271 3.11953 21.3089 7.33771 21.3089 12.5014C21.3089 17.665 17.1271 21.8832 11.9635 21.8832Z",
    fill: "#d2294b"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInfoIconBlue);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/info-icon-blue.e68150e052eded4b4cb226cac440fd73.svg";